/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "entityInheritanceDefs",
    graphQL: "EntityInheritanceDef",
    name: "Entity Inheritance Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: "entityInheritanceDefs",
    onModify: ['groupDef'],
    fields: (types) => { return {
        id: {
            name: "Entity Inheritance Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        entityDef: {
            name: "Entity Def",
            type: "relation",
            to: () => types['entityDefs'],
            defaultValue: (entityDef) => {
                return entityDef['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        entityRelationDef: {
            name: "Entity Relation Definition",
            to: () => types['entityRelationDefs'],
            type: "relation",
            relativeTo: ['entityRelationEntityDef'],
            visibility: (data) => { return data['type'] === 'has-a'; }
        },
        entityRelationEntityDef: {
            name: "Entity Relation Definition Entity",
            to: () => types['entityDefs'],
            type: "relation",
        },
        inheritedFrom: {
            name: "Entity Ihnerited from",
            type: "relation",
            to: () => types['entityDefs'],
            required: true
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: "is-a",
            values: {
                "is-a": {
                    name: "Is-a",
                    description: "Truck is-a car",
                },
                "has-a": {
                    name: "Has-a",
                    description: "Car has-a wheel",
                }
            }
        },
        contextName: {
            name: "Context Name",
            type: "string",
            translatable: true,
            defaultValue: "",
            visibility: (data) => { return data['type'] === 'has-a'; }
        },

        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        inherited_from: {
            type: 'oneToMany',
            to: types['entityDefs'],
            foreignKeys: [
                {
                    from: "id",
                    to: "inheritedFrom_id"
                }
            ],
            shouldFollow: false
        }
    }; }
});
